import { render, staticRenderFns } from "./car-configurations.vue?vue&type=template&id=8cff271a"
import script from "./car-configurations.vue?vue&type=script&lang=js"
export * from "./car-configurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports